import { useAddProductMutation, useFetchProductsQuery } from "../store"
import ProductsListItem from "./ProductsListItem"
import Button from "./Button"
import { faker } from "@faker-js/faker"

const ProductsList = ({ store }) => {
  const { data, isFetching, error } = useFetchProductsQuery(store)
  const [addProduct, resultAddProduct] = useAddProductMutation()
  console.log(data)

  const handleAddProduct = () => {
    addProduct({
      code: Math.round(Math.random() * 9999),
      name: faker.commerce.product(),
      price: faker.commerce.price(),
      store: store.id,
    })
  }

  let content, heading

  if (isFetching) {
    heading = <p>Loading...</p>
  } else if (error) {
    content = <p>Error: {error.message}</p>
  } else {
    content = data.map((product) => (
      <ProductsListItem key={product.id} product={product} />
    ))
    heading = `${data?.length} ${
      data?.length === 1 ? "Product" : "Products"
    } were
    found at ${store.name}`
  }

  return (
    <div className="m-3">
      <div className="flex flex-row justify-between items-center">
        <h3 className="text-gray-300 text-sm">{heading}</h3>
        <Button onClick={handleAddProduct} loading={resultAddProduct.isLoading}>
          + Add Product
        </Button>
      </div>
      {content}
      {resultAddProduct.isError && <p>Error while adding the product</p>}
    </div>
  )
}

export default ProductsList
